// Nombre de la promo de una línea en los desgloses del wizard (slot `promotionLabel`).
import type { PromotionLabelContext } from '@/domains/sales/wizard/components/LineLabels';
import { useSalePromotionEvaluation } from '../api/useWizardPromotions';
import { evaluatedPromotionName } from '../lib/giftPanel';
import { paymentOptionsChipLabel } from '../lib/promotionAppliesTo';
import { rememberedPaymentLabel, rememberedPromotionName } from '../lib/promotionNames';
import { PaymentOptionsChip } from './PaymentOptionsChip';

export interface PromotionNameLabelProps extends PromotionLabelContext {
    sessionId: string;
}

export function PromotionNameLabel({
    sessionId,
    promotionId,
    promotionVersion,
    format,
    fallback,
    withAudience = false,
}: PromotionNameLabelProps) {
    const { data } = useSalePromotionEvaluation(sessionId);
    // Pausada, Promociones ya no la lista: queda el nombre que se vio antes en la sesión.
    const name =
        evaluatedPromotionName(data, promotionId, promotionVersion) ??
        rememberedPromotionName(sessionId, promotionId);
    const evaluated = data?.promotions.find((p) => p.promotionId === promotionId);
    const chipLabel = evaluated
        ? paymentOptionsChipLabel(evaluated)
        : rememberedPaymentLabel(sessionId, promotionId);
    return (
        <>
            {name === undefined ? fallback : format(name)}
            {withAudience && chipLabel && (
                <>
                    {' '}
                    <PaymentOptionsChip label={chipLabel} />
                </>
            )}
        </>
    );
}
